import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserProvider } from '../user/user';
import { ContribuaProvider } from '../contribua/contribua';
import { finalize } from 'rxjs/operators';
import { LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PessoaProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(
    public http: HttpClient,
    public userProvider: UserProvider,
    public ContribuaProvider: ContribuaProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
  ) {}

  possuiSolicitacao(idPessoa, tipo, idGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/possui-solicitacao', {
        idPessoa: idPessoa,
        tipo: tipo,
        idGrupo: idGrupo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getAniversariantes() {
    return this.http.get<any>(this.baseUrl + '/aniversariantes/aniversariantes-do-dia').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getAniversariantesMes() {
    return this.http.get<any>(this.baseUrl + '/aniversariantes/aniversariantes-mes').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getBuscaGrupos(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/aniversariantes/busca-grupos', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          q: filtro.q,
          idGrupo: filtro.idGrupo,
          dayMonth: filtro.dayMonth,
          participante: filtro.participante,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          grupos: data.body,
          pagination: pag,
        };
      });
  }

  getbyId(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-by-id', {
        params: {
          expand: 'contato,endereco,hasMda,qtdministerios,qtdgrupos,apiKey,instituicao',
          id: idPessoa,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  verifyIfIsPerson(id) {
    return this.http
    .get<any>(this.baseUrl + '/pessoa/verify-if-is-person', {
      params: {
        id: id,
      },
    })
    .map((data) => {
      return !data.error ? data : false;
    });
  }

  getStatusPessoa(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-status-pessoa', {
        params: { idPessoa: idPessoa },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getFamiliaresbyId(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-familiares-by-id', {
        params: { id: idPessoa },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getPessoasProfissao(idProfissao) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/pessoas-profissao', {
        params: { idProfissao: idProfissao },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getFamiliaresAutorizados() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-familiares-autorizados').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getFamiliaresAutorizadosById(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-familiares-autorizados-by-id', {
        params: { idPessoa: idPessoa },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getTipoPessoa() {
    return this.http.post<any>(this.baseUrl + '/pessoa/get-tipo-pessoa', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getPessoaFuncao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/pessoa-funcao').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getSubtipoPessoa(idTipo) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/get-subtipo-pessoa', {
        idTipo: idTipo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getTipoMembro() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-tipo-membro').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getTipoVisitante() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-tipo-visitante').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getTipoOcorrencia() {
    return this.http.get<any>(this.baseUrl + '/pessoa/tipo-ocorrencia').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  /**
   * Verifica se CPF inserido é valido
   *
   * @param string $cpf numero do cpf
   * @param string $nome nome
   * @return
   */
  public cpfValido(cpf, nome) {
    var loader: any = this.loadingCtrl.create({
      content: this.translate.instant('Carregando'),
    });
    loader.present();
    return this.http
      .post<any>(this.baseUrl + '/pessoa/cpf-valido', {
        cpf: cpf,
        idInstituicao: this.ContribuaProvider.idInstituicao,
        nome: nome,
      })
      .pipe(finalize(() => loader.dismiss()))
      .map((resposta) => {
        return resposta;
      });
  }

  public cpfValidoNovo(cpf, idPessoa) {
    var loader: any = this.loadingCtrl.create({
      content: this.translate.instant('Carregando'),
    });
    loader.present();
    return this.http
      .post<any>(this.baseUrl + '/pessoa/cpf-valido-novo', {
        cpf: cpf,
        idInstituicao: this.ContribuaProvider.idInstituicao,
        id: idPessoa,
      })
      .pipe(finalize(() => loader.dismiss()))
      .map((resposta) => {
        return resposta;
      });
  }

  /**
   * Verifica se CPF já esta cadastrado na base de dados
   * Author: Fernando Binasco
   */
  public cpfCadastrado(cpf) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/cpf-cadastrado', {
        cpf: cpf,
        idInstituicao: this.ContribuaProvider.idInstituicao,
      })
      .map((resposta) => {
        return resposta;
      });
  }

  getPessoas(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/buscar', {
        observe: 'response',
        params: {
          expand: 'contato',
          page: pag.currentPage,
          'per-page': '10',
          q: filtro.q,
          t: filtro.t,
          idGrupo: filtro.idGrupo ? filtro.idGrupo : '',
          idOperacao: filtro.idOperacao ? filtro.idOperacao : '',
          idade: filtro.idade ? filtro.idade : '',
          idDependente: filtro.idDependente ? filtro.idDependente : '',
          id: filtro.id,
          filtroInstituicaoMultiIgreja: filtro.filtroInstituicaoMultiIgreja ? filtro.filtroInstituicaoMultiIgreja : false,
          isOracao: filtro.isOracao,
          idInstituicaoFiltroOvelhinha: filtro.idInstituicaoFiltroOvelhinha ? filtro.idInstituicaoFiltroOvelhinha : '',
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          pessoas: data.body,
          pagination: pag,
        };
      });
  }

  getVisitantes(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/buscar-visitante', {
        observe: 'response',
        params: {
          expand: 'contato',
          page: pag.currentPage,
          'per-page': '10',
          q: filtro.q,
          t: filtro.t,
          id: filtro.id,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          pessoas: data.body,
          pagination: pag,
        };
      });
  }

  getProfissoes(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/profissoes', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          profissoes: data.body,
          pagination: pag,
        };
      });
  }

  getContatos(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/contatos', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          contatos: data.body,
          pagination: pag,
        };
      });
  }

  addProfissao(profissao, idInstituicao = null) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/add-profissao', {
        profissao: profissao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  criarPessoa(pessoa) {
    return this.http.post<any>(this.baseUrl + '/adm/add-pessoa', pessoa).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  buscarMigracaoConfiguracao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/buscar-migracao-configuracao').map((data) => {
      return data && !data.error ? data : false;
    });
  }

  updatePessoaContato(idPessoa, pessoa, contato) {
    return this.http
      .post<any>(this.baseUrl + '/adm/update-pessoa-contato', {
        id: idPessoa,
        pessoa: pessoa,
        contato: contato,
      })
      .map((data) => {
        if (!data.error) {
          this.userProvider.atualizarDadosPessoa().subscribe(() => {});
          return data;
        } else {
          return false;
        }
      });
  }

  salvarEndereco(endereco) {
    return this.http.post<any>(this.baseUrl + '/pessoa/endereco', endereco).map((data) => {
      if (!data.error) {
        this.userProvider.atualizarDadosPessoa().subscribe(() => {});
        return data;
      } else {
        return false;
      }
    });
  }

  salvarEnderecoGoogle(idEndereco, enderecoCompleto, idPais, objEndereco) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/endereco-google', {
        idEndereco: idEndereco,
        formatado: enderecoCompleto,
        idPais: idPais,
        objEndereco: objEndereco,
      })
      .map((data) => {
        if (!data.error) {
          this.userProvider.atualizarDadosPessoa().subscribe(() => {});
          return data;
        } else {
          return false;
        }
      });
  }

  updateFoto(base64, idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/upload-foto', {
        foto: base64,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          this.userProvider.atualizarDadosPessoa().subscribe(() => {});
          return data;
        } else {
          return false;
        }
      });
  }

  updateFotoPessoaSemId(base64) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/upload-foto-pessoa-sem-id', {
        foto: base64,
      })
      .map((data) => {
        if (!data.error) {
          this.userProvider.atualizarDadosPessoa().subscribe(() => {});
          return data;
        } else {
          return false;
        }
      });
  }

  migrarCadastro(cadastro) {
    return this.http.post<any>(this.baseUrl + '/pessoa/migrar-cadastro', cadastro).map((data) => {
      return data;
    });
  }

  migrarGrupos(idPessoa, idTipoPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/search-pessoa-grupo', {
        idPessoa: idPessoa,
        idTipoPessoa: idTipoPessoa,
      })
      .map((data) => {
        return data;
      });
  }

  criarAnotacao(entidade, idEntidade, anotacao) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/criar-anotacao', {
        entidade: entidade,
        idEntidade: idEntidade,
        anotacao: anotacao,
      })
      .map((data) => {
        return data;
      });
  }

  editAnotacao(id, anotacao) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/edit-anotacao', {
        id: id,
        anotacao: anotacao,
      })
      .map((data) => {
        return data;
      });
  }

  getAnotacao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-anotacoes').map((data) => {
      return data;
    });
  }

  getAviso() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-aviso').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getDocumentos(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-documentos', {
        observe: 'response',
        params: {
          idPessoa: idPessoa,
        },
      })
      .map((data) => {
        return data.body;
      });
  }

  getPdf(file) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-documentos', {
        observe: 'response',
        params: {
          file: file,
        },
      })
      .map((data) => {
        return data.body;
      });
  }

  getNotification() {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-notification', {
        observe: 'response',
      })
      .map((data) => {
        return data.body;
      });
  }

  getCountNotification() {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/get-count-notification', {
        observe: 'response',
      })
      .map((data) => {
        return data.body;
      });
  }

  updateNotification(idNotification) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/update-notification', {
        observe: 'response',
        params: {
          idNotification: idNotification,
        },
      })
      .map((data) => {
        return data.body;
      });
  }

  deleteNotification(idNotification) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/delete-notification', {
        observe: 'response',
        params: {
          idNotification: idNotification,
        },
      })
      .map((data) => {
        return data.body;
      });
  }

  getTokenTemp(idPessoa){
    return this.http.get<any>(this.baseUrl + '/pessoa/token-temp', {
        params: { 'idPessoa': idPessoa }
      }
    ).map(data => {
      return !data.error ? data : false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/pessoa/pessoa.ts